<ng-container *ngIf="systemInfo?.Plant_Name">
  <div class="plant-bar me-3">
    <span class="me-1">
      <ng-container *ngIf="systemInfo.Plant_Icon">
        <img
          [src]="systemInfo.getIconBase64URL() | bypassSecurityURL"
          alt="Icon"
          height="50px"
          width="auto"/>
      </ng-container>
    </span>
    <span>
      {{ systemInfo.Plant_Name }}
    </span>
  </div>
</ng-container>
